export default __webpack_public_path__ + "static/media/env-high.c8fc581e.png";